import { UserData } from "components/Sidebar/Sidebar_Principal";
import WebPresupuesto from "components/Varios/Dashboards/WebPresupuesto";
import React from "react";
import { useEffect, useState } from "react";
import { authenticationService } from "services/authentication.service";



export default function DashboarDirectivo() {

    const [infoUsuario, setinfoUsuario] = useState<UserData>();

    useEffect(() => {
        setinfoUsuario(authenticationService.currentUserValue);
    }, [])

    return (
        <div>
            {infoUsuario && (
                <WebPresupuesto
                    roles={infoUsuario.roles_usuario}
                    nombres={infoUsuario.nombres}
                    apellidos={infoUsuario.apellidos}
                    usuario={infoUsuario.usuario}
                    autorizado={true}
                />
            )
            }
        </div>
    );



}